import { render, staticRenderFns } from "./TeacherNewDialog.vue?vue&type=template&id=4223acbe&scoped=true"
import script from "./TeacherNewDialog.vue?vue&type=script&lang=js"
export * from "./TeacherNewDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherNewDialog.vue?vue&type=style&index=0&id=4223acbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223acbe",
  null
  
)

export default component.exports